import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the datatable for the casino report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Defines the view as a datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            columns: [
                // Column definitions for the datatable
                { id: 'Id', header: 'Id', width: 100, sort: 'int' },
                {
                    id: 'Username',
                    header: _('Usuario'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Game', header: _('Juego'), width: 100, sort: 'int' },
                {
                    id: 'ProviderName',
                    header: _('Proveedor'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Bets', header: _('Apuestas'), width: 100, sort: 'int' },
                {
                    id: 'Stakes',
                    header: _('Valor'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type for this column
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Winnings',
                    header: _('Premios'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type for this column
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Categorie',
                    header: _('Ganancias'), // Localized header
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type for this column
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Profit',
                    header: _('Beneficios %'), // Localized header
                    width: 150,
                    sort: 'int',
                },
            ],
            footer: true, // Enables footer
            math: true, // Enables mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport', // API endpoint for data
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // Store the grid's URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering the report
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Build query string based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        '-' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        '-' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            '-' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load new data with filters
            );
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the datatable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click in the datatable
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
